import React from "react";
import {
  List,
  Datagrid,
  TextField,
  NumberField,
  BooleanField,
  EditButton,
  ShowButton,
  DeleteButton,
  ChipField,
  ReferenceField,
  TopToolbar,
  CreateButton,
  ExportButton,
  Filter,
  TextInput,
  SelectInput,
} from "react-admin";

const limiterTypes = [
  { id: "messages_per_month", name: "Сообщения в месяц" },
  { id: "challenges_create_or_join", name: "Челленджи" },
  { id: "ai_requests_per_day", name: "AI запросы в день" },
  { id: "storage_gb", name: "Хранилище (GB)" },
  { id: "team_members", name: "Участники команды" },
];

const limiterPeriods = [
  { id: "daily", name: "День" },
  { id: "weekly", name: "Неделя" },
  { id: "monthly", name: "Месяц" },
  { id: "yearly", name: "Год" },
  { id: "total", name: "Общий" },
];

const LimiterFilter = (props: any) => (
  <Filter {...props}>
    <TextInput label="Название" source="name" alwaysOn />
    <SelectInput label="Тип" source="type" choices={limiterTypes} alwaysOn />
    <SelectInput label="Период" source="period" choices={limiterPeriods} />
    <SelectInput
      label="Активен"
      source="isActive"
      choices={[
        { id: true, name: "Да" },
        { id: false, name: "Нет" },
      ]}
    />
  </Filter>
);

const SubscriptionLimiterListActions = () => (
  <TopToolbar>
    <CreateButton />
    <ExportButton />
  </TopToolbar>
);

export const SubscriptionLimiterList = () => {
  return (
    <List
      actions={<SubscriptionLimiterListActions />}
      filters={<LimiterFilter />}
      title="Лимитеры подписок"
    >
      <Datagrid rowClick="show">
        <TextField source="name" label="Название" />
        <ChipField source="type" label="Тип" />
        <NumberField source="limitValue" label="Лимит" />
        <ChipField source="period" label="Период" />
        <BooleanField source="isHardLimit" label="Жесткий" />
        <BooleanField source="isActive" label="Активен" />
        <ReferenceField
          source="subscriptionPlanId"
          reference="subscriptionPlans"
          label="План подписки"
          link="show"
        >
          <ChipField source="name" />
        </ReferenceField>
        <EditButton />
        <ShowButton />
        <DeleteButton />
      </Datagrid>
    </List>
  );
};
